module.exports = __webpack_public_path__ + "img/box.a921c766.png";